import { render, staticRenderFns } from "./AdminTest.vue?vue&type=template&id=349e1c8a&scoped=true"
import script from "./AdminTest.vue?vue&type=script&lang=js"
export * from "./AdminTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349e1c8a",
  null
  
)

export default component.exports